<template>
    <el-card class="box-card" shadow="always">
        <div class="form-item">
            <span class="label">*排列序号</span>
            <el-input-number v-model="seoInfo.sort" :min="1" clearable class="name-input" placeholder="请输入排列序号" style="width: 300px" /></el-input-number>
        </div>

        <div class="form-item">
            <span class="label">*解决方案名称</span>
            <el-input v-model="seoInfo.name" clearable style="width: 300px" class="name-input" placeholder="请输入解决方案名称" />
        </div>

        <div class="seo_module">
            <div class="seo_set">*SEO配置</div>
            <div class="seo_wrap">
                <div class="form-item">
                    <span class="label">*页面标题：</span>
                    <el-input v-model="seoInfo.seo_t" clearable style="width: 300px" class="name-input" placeholder="请输入页面标题：" />
                </div>

                <div class="form-item">
                    <span class="label co_w">*描述：</span>
                    <el-input v-model="seoInfo.seo_d" clearable style="width: 300px" class="name-input" placeholder="请输入描述" />
                </div>

                <div class="form-item">
                    <span class="label co_w">*关键词：</span>
                    <el-input v-model="seoInfo.seo_k" clearable style="width: 300px" class="name-input" placeholder="请输入关键词" />
                </div>
            </div>
        </div>
    </el-card>
</template>
<script>
import utils from '@/jslibs/utils';
export default {
    data() {
        return {
            loading: false,
            seoInfo: {
                sort: "",
                name: "",
                seo_t: "",
                seo_d: "",
                seo_k: ""
            }
        };
    },

    methods: {
        verifyInput() {
            const { sort, name, seo_t, seo_d, seo_k } = this.seoInfo;
            if (!sort) {
                this.$notify.error({ title: '请输入名称排序' });
                return false
            }
            if (!name) {
                this.$notify.error({ title: '请输入解决方案名称' });
                return false
            }
            if (!seo_t) {
                this.$notify.error({ title: '请输入SEO页面标题' });
                return false
            }
            if (!seo_d) {
                this.$notify.error({ title: '请输入seo描述' });
                return false
            }
            if (!seo_k) {
                this.$notify.error({ title: '请输入seo关键词' });
                return false
            }
            return true
        }
    }
};
</script>
<style lang="less" scoped>
    .box-card{
        margin-bottom: 60px;
        .form-item {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .icon_type{
                margin-right: 20px;
            }
        }
        .label {
            display: inline-block;
            width: 100px;
            flex-shrink: 0;
        }
        .el-select{
            width: 300px;
        }
        .seo_module{
            margin-top: 60px;
            .seo_set{
                margin: 20px 0;
            }
            .seo_wrap{
                display: flex;
                flex-wrap: wrap;
                border: 1px solid #ccc;
                margin: 20px 0;
                padding: 20px;
                .form-item {
                    margin-left: 0;
                    margin-right: 60px;
                    .label{
                        width: 80px;
                    }
                }
            }
        }

    }
</style>
